// John Eldhose 20181219
import { RestfulPost } from './Restful';

export async function upgradedFrom(data) {
  const upg = await RestfulPost('upgradedFrom', {data: data}, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return upg;
}



// WEBPACK FOOTER //
// ./src/Api/upgradedFrom.js